
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("kSuJt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7a9a5c565170f5ad$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kW74I = parcelRequire("kW74I");

var $9xsAN = parcelRequire("9xsAN");

var $5PRxC = parcelRequire("5PRxC");

var $df3S9 = parcelRequire("df3S9");

var $gfzrp = parcelRequire("gfzrp");
// eslint-disable-next-line jira/react/no-class-components
class $7a9a5c565170f5ad$var$AddItem extends (0, $5uXOq.Component) {
    render() {
        const { addItem: addItem } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kW74I.default), null, addItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gfzrp.default), {
            itemType: addItem.type,
            SelectItemTypeModal: this.renderSelectItemTypeModal,
            AddLinkModal: this.renderAddLinkModal,
            AddRepositoryModal: this.renderAddRepositoryModal
        }));
    }
    constructor(...args){
        super(...args), this.onClose = ()=>{
            this.props.onAddItemCompleted({
                item: undefined
            });
        }, this.renderAddLinkModal = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9xsAN.default), {
                projectId: this.props.projectKey,
                baseUrl: this.props.baseUrl,
                onCompleted: this.props.onAddItemCompleted,
                addItemButtonRef: this.props.addItemButtonRef
            }), this.renderAddRepositoryModal = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5PRxC.default), {
                projectId: this.props.projectKey,
                baseUrl: this.props.baseUrl,
                onCompleted: this.props.onAddItemCompleted
            }), this.renderSelectItemTypeModal = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $df3S9.default), {
                pages: this.props.pages,
                showPagesSelector: this.props.showPagesSelector,
                onAddLink: this.props.onAddLink,
                onAddRepo: this.props.onAddRepo,
                onClose: this.onClose,
                onCloseComplete: this.props.onCloseComplete,
                addItemButtonRef: this.props.addItemButtonRef
            });
    }
}
var $7a9a5c565170f5ad$export$2e2bcd8739ae039 = $7a9a5c565170f5ad$var$AddItem;

});
parcelRegister("9xsAN", function(module, exports) {

$parcel$export(module.exports, "default", () => $a866bdcf77bd697c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nE2n = parcelRequire("7nE2n");

var $8RXs9 = parcelRequire("8RXs9");

var $7ZJmF = parcelRequire("7ZJmF");

var $fsXyP = parcelRequire("fsXyP");

var $4zTCd = parcelRequire("4zTCd");
const $a866bdcf77bd697c$var$AddLinkModalWithIntl = (0, $8RXs9.default)((0, $4zTCd.default));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a866bdcf77bd697c$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7nE2n.default), null, (flagService)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a866bdcf77bd697c$var$AddLinkModalWithIntl, {
            ...props,
            flagService: flagService,
            Content: (0, $fsXyP.default),
            Header: (0, $7ZJmF.default)
        }));

});
parcelRegister("7nE2n", function(module, exports) {

$parcel$export(module.exports, "default", () => $4855eee5a10070a5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");
const $4855eee5a10070a5$var$FlagServiceSubscriber = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children((0, $pa9q9.flagService)));
var $4855eee5a10070a5$export$2e2bcd8739ae039 = $4855eee5a10070a5$var$FlagServiceSubscriber;

});

parcelRegister("7ZJmF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5db6ab315ebb63d0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hhYyV = parcelRequire("hhYyV");

var $blhnb = parcelRequire("blhnb");
const $5db6ab315ebb63d0$var$Header = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $blhnb.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hhYyV)))
    });
var $5db6ab315ebb63d0$export$2e2bcd8739ae039 = $5db6ab315ebb63d0$var$Header;

});
parcelRegister("hhYyV", function(module, exports) {
module.exports = new URL("link.4cfe7932.svg", import.meta.url).toString();

});

parcelRegister("blhnb", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf50477ba4cb29dd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $cf50477ba4cb29dd$var$ImageHeader = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cf50477ba4cb29dd$var$HeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cf50477ba4cb29dd$var$BackgroundContainer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cf50477ba4cb29dd$var$ImageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cf50477ba4cb29dd$var$ImageContainer, {
        src: props.src,
        alt: ""
    })));
var $cf50477ba4cb29dd$export$2e2bcd8739ae039 = $cf50477ba4cb29dd$var$ImageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cf50477ba4cb29dd$var$ImageContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb17n1 _4t3i7iqz",
            __cmplp.className
        ])
    });
});
const $cf50477ba4cb29dd$var$HeaderContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $cf50477ba4cb29dd$var$BackgroundContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1k7a _kqswstnw _1ltvidpf _1xi2idpf _154iidpf _4t3i1wqb _bfhkfg4m _1eaz1osq _1f00gktf _1g0kx099",
            __cmplp.className
        ])
    });
});
const $cf50477ba4cb29dd$var$ImageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1e0c1txw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("fsXyP", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ecb4d2083183730$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gxpxd = parcelRequire("gxpxd");


var $l5pQE = parcelRequire("l5pQE");
const $8ecb4d2083183730$var$messages = (0, $l5pQE.default)((0, $27f32c1fbb856eaf$export$58125ce2bb1c3378));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8ecb4d2083183730$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gxpxd.default), {
        invalidUrlError: $8ecb4d2083183730$var$messages.invalidUrlError,
        urlCaption: $8ecb4d2083183730$var$messages.urlCaption,
        urlPlaceholder: $8ecb4d2083183730$var$messages.urlPlaceholder,
        nameCaption: $8ecb4d2083183730$var$messages.nameCaption,
        namePlaceholder: $8ecb4d2083183730$var$messages.namePlaceholder,
        urlAndNameLocked: true,
        onChange: props.onDataChange
    });

});
parcelRegister("gxpxd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1e808793b41fb69$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $aZsz6 = parcelRequire("aZsz6");

var $7folp = parcelRequire("7folp");
var $k5Wbc = parcelRequire("k5Wbc");
var $4EHpO = parcelRequire("4EHpO");

var $9r7BT = parcelRequire("9r7BT");

var $az4zD = parcelRequire("az4zD");


var $6OZbr = parcelRequire("6OZbr");

var $8hTwx = parcelRequire("8hTwx");
// eslint-disable-next-line jira/react/no-class-components
class $c1e808793b41fb69$var$SmartAdd extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            url: '',
            name: '',
            urlAndNameLocked: true,
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    constructor(props){
        // @ts-expect-error - TS2554 - Expected 1-2 arguments, but got 0.
        super(), this.validate = (value)=>{
            if (value === undefined) return undefined;
            const isUrlSane = (0, $6OZbr.urlSanityCheck)(value);
            if (isUrlSane) {
                const { name: name } = this.state;
                if (this.props.urlAndNameLocked && name.length === 0) {
                    // This prop copies the host of the url as the name, as a kind of prefill behaviour
                    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(value, {});
                    this.setState({
                        url: value,
                        name: parsedUrl.host ? parsedUrl.host : value,
                        hasUrlError: false
                    });
                } else this.setState({
                    url: value,
                    hasUrlError: false
                });
            } else {
                this.setState({
                    url: value,
                    hasUrlError: true
                });
                return 0, $27f32c1fbb856eaf$export$3746846b4d8615c3;
            }
            return undefined;
        }, this.onNameChanged = ({ target: { value: value } })=>{
            this.setState({
                name: value
            });
        };
        const { url: url, name: name } = props;
        this.state = {
            url: url,
            name: name,
            hasUrlError: false
        };
    }
    componentDidUpdate(prevProps, prevState) {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'State'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Readonly<State>'.
        if (Object.keys(this.state).some((key)=>prevState[key] !== this.state[key])) {
            const { onChange: onChange } = this.props;
            const { name: name, url: url, hasUrlError: hasUrlError } = this.state;
            onChange({
                name: name,
                url: url,
                hasError: hasUrlError
            });
        }
    }
    render() {
        const { urlCaption: urlCaption, urlPlaceholder: urlPlaceholder, nameCaption: nameCaption, namePlaceholder: namePlaceholder, invalidUrlError: invalidUrlError, intl: { formatMessage: formatMessage } } = this.props;
        const { name: name, url: url } = this.state;
        return(// Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7folp.default), {
            onSubmit: ()=>{}
        }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4EHpO.default), {
                isRequired: true,
                label: formatMessage(urlCaption),
                name: "url",
                validate: this.validate
            }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9r7BT.default), {
                    ...fieldProps,
                    placeholder: formatMessage(urlPlaceholder),
                    value: url,
                    type: "url"
                }), error === (0, $27f32c1fbb856eaf$export$3746846b4d8615c3) && invalidUrlError != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k5Wbc.ErrorMessage), null, formatMessage(invalidUrlError)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4EHpO.default), {
                isRequired: true,
                label: formatMessage(nameCaption),
                name: "description",
                // @ts-expect-error - TS2322 - Type '{ children: ({ fieldProps }: { fieldProps: FieldProps<string, HTMLInputElement>; error?: string | undefined; valid: boolean; meta: Meta; }) => Element; isRequired: true; label: string; name: string; value: string; }' is not assignable to type 'IntrinsicAttributes & FieldComponentProps<string, HTMLInputElement>'.
                value: name
            }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9r7BT.default), {
                    ...fieldProps,
                    placeholder: formatMessage(namePlaceholder),
                    onChange: this.onNameChanged,
                    value: name,
                    "aria-describedby": "pro-tip-description"
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8hTwx.default), {
                id: "pro-tip-description"
            }))));
    }
}
var $c1e808793b41fb69$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($c1e808793b41fb69$var$SmartAdd);

});
parcelRegister("7folp", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $989b7d35312a49bd$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $989b7d35312a49bd$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $989b7d35312a49bd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lqWDn = parcelRequire("lqWDn");

var $8tHJX = parcelRequire("8tHJX");

var $gZL7V = parcelRequire("gZL7V");
const $989b7d35312a49bd$export$c24727297075ec6a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $989b7d35312a49bd$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
function $989b7d35312a49bd$export$2e2bcd8739ae039(props) {
    const formRef = (0, $5uXOq.useRef)(null);
    const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $5uXOq.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $lqWDn.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(values, name, value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $5uXOq.useState)({
        dirty: false,
        submitting: false
    });
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $5uXOq.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: {
                    onSubmit: handleSubmit,
                    ref: formRef,
                    onKeyDown: handleKeyDown
                },
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change
            }) : children();
            return result === undefined ? null : result;
        }
        return children;
    })();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($989b7d35312a49bd$export$c24727297075ec6a.Provider, {
        value: FormContextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($989b7d35312a49bd$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled,
            children: childrenContent
        })
    });
}

});
parcelRegister("lqWDn", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $f9a9822f8af64e2a$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $f9a9822f8af64e2a$export$97cd7fc25dd32915);
$parcel$export(module.exports, "ARRAY_ERROR", () => $f9a9822f8af64e2a$export$735bebc8ffabf28a);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $f9a9822f8af64e2a$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $f9a9822f8af64e2a$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $f9a9822f8af64e2a$export$f681a8129d2e9d28);

var $bS32t = parcelRequire("bS32t");

var $ddEsc = parcelRequire("ddEsc");
//      
var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
var $f9a9822f8af64e2a$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
    string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $f9a9822f8af64e2a$var$keysCache = {};
var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
    }
    return $f9a9822f8af64e2a$var$keysCache[key];
};
//      
var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $f9a9822f8af64e2a$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
    var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $ddEsc.default)(current, [
                key
            ].map($f9a9822f8af64e2a$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
};
var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
    var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
    var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $f9a9822f8af64e2a$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                    shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values)); // clone to avoid writing
            if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                    var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
        var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $bS32t.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $bS32t.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("8tHJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $62c2f612c5adb35a$export$2e2bcd8739ae039);

var $lqWDn = parcelRequire("lqWDn");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $lqWDn.getIn)(errors, input.name);
    });
};
//      
var $62c2f612c5adb35a$var$noop = function noop() {};
var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;

});

parcelRegister("gZL7V", function(module, exports) {

var $ajB7H = parcelRequire("ajB7H");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $c5f6e64373be0bfc$var$set(object, path, value) {
    return object == null ? object : $ajB7H(object, path, value);
}
module.exports = $c5f6e64373be0bfc$var$set;

});


parcelRegister("k5Wbc", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $17b56f3c99dc4004$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $17b56f3c99dc4004$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $17b56f3c99dc4004$export$5505afb209a532c8);
$parcel$export(module.exports, "MessageWrapper", () => $17b56f3c99dc4004$export$ec445f12f63100a5);
/* messages.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iZXAi = parcelRequire("iZXAi");

var $35I2R = parcelRequire("35I2R");

var $bU9TL = parcelRequire("bU9TL");
const $17b56f3c99dc4004$var$messageStyles = null;
const $17b56f3c99dc4004$var$messageAppearanceStyles = {
    default: "_syaz1wmz",
    error: "_syaze6sf",
    valid: "_syazy73q"
};
const $17b56f3c99dc4004$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
const $17b56f3c99dc4004$var$IconWrapper = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            $17b56f3c99dc4004$var$iconWrapperStyles.root
        ]),
        children: children
    });
const $17b56f3c99dc4004$var$messageIcons = {
    error: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iZXAi))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "error"
    }),
    valid: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($35I2R))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "success"
    })
};
const $17b56f3c99dc4004$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $17b56f3c99dc4004$var$messageIcons[appearance];
    const messageRef = (0, $5uXOq.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $5uXOq.useState)(false);
    const { isWrapper: isWrapper } = (0, $5uXOq.useContext)($17b56f3c99dc4004$var$MessageWrapperContext);
    (0, $5uXOq.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined,
        className: (0, $bwpsq.default)([
            "_zulp12x7 _11c8dcr7 _1e0c1txw _1bah1q9y _1pfh1b66",
            $17b56f3c99dc4004$var$messageAppearanceStyles[appearance]
        ]),
        children: [
            icon && /*#__PURE__*/ (0, $2OMIu.jsx)($17b56f3c99dc4004$var$IconWrapper, {
                children: icon
            }),
            content
        ]
    });
};
const $17b56f3c99dc4004$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bU9TL.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2OMIu.jsx)($17b56f3c99dc4004$var$Message, {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId,
                children: children
            })
    });
const $17b56f3c99dc4004$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bU9TL.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2OMIu.jsx)($17b56f3c99dc4004$var$Message, {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId,
                children: children
            })
    });
const $17b56f3c99dc4004$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bU9TL.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2OMIu.jsx)($17b56f3c99dc4004$var$Message, {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId,
                children: children
            })
    });
/**
 * __Message wrapper context__
 *
 * A message wrapper context allows the children to check
 * if it is contained within the MessageWrapper.
 */ const $17b56f3c99dc4004$var$MessageWrapperContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isWrapper: false
});
const $17b56f3c99dc4004$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)($17b56f3c99dc4004$var$MessageWrapperContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper",
            children: children
        })
    });
};

});
parcelRegister("iZXAi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::98606756a92a07f2e7585c76d3cbd084>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd4c24b8075762c6$var$_react = $dd4c24b8075762c6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $dd4c24b8075762c6$var$_error = $dd4c24b8075762c6$var$_interopRequireDefault((parcelRequire("65KuH")));

var $dd4c24b8075762c6$var$_error2 = $dd4c24b8075762c6$var$_interopRequireDefault((parcelRequire("hWOvD")));
function $dd4c24b8075762c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dd4c24b8075762c6$var$ErrorIcon = (props)=>/*#__PURE__*/ $dd4c24b8075762c6$var$_react.default.createElement($dd4c24b8075762c6$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $dd4c24b8075762c6$var$_error2.default
    }, props));
$dd4c24b8075762c6$var$ErrorIcon.Name = 'ErrorIconMigration';
var $dd4c24b8075762c6$var$_default = module.exports.default = $dd4c24b8075762c6$var$ErrorIcon;

});
parcelRegister("65KuH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d97879d6b889ef4621929c7dd705b0ff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $46f7467bbb627311$var$_react = $46f7467bbb627311$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $46f7467bbb627311$var$_baseNew = $46f7467bbb627311$var$_interopRequireDefault((parcelRequire("enEmH")));
function $46f7467bbb627311$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Error".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $46f7467bbb627311$var$ErrorIcon = (props)=>/*#__PURE__*/ $46f7467bbb627311$var$_react.default.createElement($46f7467bbb627311$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.384 5.116 5.116.384a1.25 1.25 0 0 1 1.768 0l4.732 4.732a1.25 1.25 0 0 1 0 1.768l-4.732 4.732a1.25 1.25 0 0 1-1.768 0L.384 6.884a1.25 1.25 0 0 1 0-1.768M6.75 2.5v4h-1.5v-4zM6 9.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$46f7467bbb627311$var$ErrorIcon.displayName = 'ErrorIcon';
var $46f7467bbb627311$var$_default = module.exports.default = $46f7467bbb627311$var$ErrorIcon;

});


parcelRegister("35I2R", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d345d1980a5e7ce7680063890c36f7e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $24040126ddf3179f$var$_react = $24040126ddf3179f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $24040126ddf3179f$var$_success = $24040126ddf3179f$var$_interopRequireDefault((parcelRequire("aZZu2")));

var $24040126ddf3179f$var$_success2 = $24040126ddf3179f$var$_interopRequireDefault((parcelRequire("8VK5X")));
function $24040126ddf3179f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $24040126ddf3179f$var$SuccessIcon = (props)=>/*#__PURE__*/ $24040126ddf3179f$var$_react.default.createElement($24040126ddf3179f$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $24040126ddf3179f$var$_success2.default
    }, props));
$24040126ddf3179f$var$SuccessIcon.Name = 'SuccessIconMigration';
var $24040126ddf3179f$var$_default = module.exports.default = $24040126ddf3179f$var$SuccessIcon;

});
parcelRegister("aZZu2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b91b2ac4848db507d9eb71a2b738b7fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $801f4b37378597d1$var$_react = $801f4b37378597d1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $801f4b37378597d1$var$_baseNew = $801f4b37378597d1$var$_interopRequireDefault((parcelRequire("enEmH")));
function $801f4b37378597d1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Success".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $801f4b37378597d1$var$SuccessIcon = (props)=>/*#__PURE__*/ $801f4b37378597d1$var$_react.default.createElement($801f4b37378597d1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6m9.389-1.77-1.153-.96-3.174 3.808L3.765 5.52l-1.153.96 1.875 2.25a.75.75 0 0 0 1.153 0z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$801f4b37378597d1$var$SuccessIcon.displayName = 'SuccessIcon';
var $801f4b37378597d1$var$_default = module.exports.default = $801f4b37378597d1$var$SuccessIcon;

});

parcelRegister("8VK5X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6807671dacf23c57$var$_react = $6807671dacf23c57$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $6807671dacf23c57$var$_success = $6807671dacf23c57$var$_interopRequireDefault((parcelRequire("cFUJ2")));
function $6807671dacf23c57$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6807671dacf23c57$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $6807671dacf23c57$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props, {
        newIcon: $6807671dacf23c57$var$_success.default
    }));
$6807671dacf23c57$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $6807671dacf23c57$var$_default = module.exports.default = $6807671dacf23c57$var$EditorSuccessIcon;

});


parcelRegister("bU9TL", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $fd4ca56d0899c490$export$3c4232819458a302);

var $5uXOq = parcelRequire("5uXOq");
const $fd4ca56d0899c490$export$3c4232819458a302 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);

});


parcelRegister("4EHpO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4338501a4bebd545$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("3joPi");

var $jJsBW = parcelRequire("jJsBW");

var $bU9TL = parcelRequire("bU9TL");

var $7folp = parcelRequire("7folp");

var $cGltd = parcelRequire("cGltd");

var $cUUCJ = parcelRequire("cUUCJ");

var $6cAn5 = parcelRequire("6cAn5");
const $4338501a4bebd545$var$fieldWrapperStyles = null;
function $4338501a4bebd545$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $4338501a4bebd545$var$isFunction(x) {
    return typeof x === 'function';
}
function $4338501a4bebd545$var$usePreviousRef(current) {
    const ref = (0, $5uXOq.useRef)(current);
    // will be updated on the next render
    (0, $5uXOq.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $4338501a4bebd545$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $4338501a4bebd545$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, $7folp.FormContext));
    const isDisabled = (0, $5uXOq.useContext)((0, $7folp.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $4338501a4bebd545$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $4338501a4bebd545$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$4338501a4bebd545$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $5uXOq.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $4338501a4bebd545$var$usePreviousRef(state);
    (0, $5uXOq.useEffect)(()=>{
        typeof $6cAn5;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $4338501a4bebd545$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($4338501a4bebd545$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const uid = (0, $jJsBW.useId)();
    const fieldId = (0, $5uXOq.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": props.testId,
        className: (0, $bwpsq.default)([
            "_1pfhu2gc"
        ]),
        children: [
            props.label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cGltd.Label), {
                htmlFor: fieldId,
                id: `${fieldId}-label`,
                testId: props.testId && `${props.testId}--label`,
                children: [
                    props.label,
                    props.isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cUUCJ.default), {}),
                    props.elementAfterLabel
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bU9TL.FieldId).Provider, {
                value: fieldId,
                children: props.children({
                    fieldProps: extendedFieldProps,
                    error: state.error,
                    valid: state.valid,
                    meta: state.meta
                })
            })
        ]
    });
}

});
parcelRegister("cGltd", function(module, exports) {

$parcel$export(module.exports, "Label", () => $6da09f2418b6f13e$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $6da09f2418b6f13e$export$ed247974535929c7);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $6da09f2418b6f13e$var$fieldsetLabelStyles = null;
const $6da09f2418b6f13e$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
const $6da09f2418b6f13e$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("legend", {
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};

});

parcelRegister("cUUCJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a7ed1e0c62cc06b$export$2e2bcd8739ae039);
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $4a7ed1e0c62cc06b$var$requiredIndicatorStyles = null;
function $4a7ed1e0c62cc06b$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $bwpsq.default)([
            "_syaz1ick _ect41gqc _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("9r7BT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7747ff173c91dd60$export$2e2bcd8739ae039);
/* text-field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $eNCZ4 = parcelRequire("eNCZ4");

var $fHpHg = parcelRequire("fHpHg");
const $7747ff173c91dd60$var$containerMedia = {
    invalid: "_srjtgir2",
    disabled: "_6up518qt"
};
const $7747ff173c91dd60$var$inputMediaDisabled = null;
const $7747ff173c91dd60$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $7747ff173c91dd60$var$disabledStyle = {
    standard: "_1h6dsyzs _bfhksyzs _syaz1lh4 _80om13gf",
    subtle: "_1h6d3acm _bfhk18uv _syaz1lh4 _80om13gf",
    none: "_1h6d3acm _bfhk18uv _syaz1lh4 _80om13gf"
};
const $7747ff173c91dd60$var$invalidStyle = null;
const $7747ff173c91dd60$var$focusWithinStyle = {
    standard: "_ochr1p6i _195er01l _bqhtq049",
    subtle: "_ochr1p6i _195er01l _bqhtq049",
    none: "_ochr3acm _195e18uv _bqhtnruj"
};
const $7747ff173c91dd60$var$hoverStyle = {
    standard: "_4cvx1elr _irr31d5g",
    subtle: "_4cvx1elr _irr31d5g",
    none: "_4cvx3acm _irr318uv"
};
const $7747ff173c91dd60$var$getContainerTextBgAndBorderColor = {
    standard: "_1h6d1elr _1dqonqa1 _syaz1fxt _80om1kdv _bfhk1j9a _srjtgir2",
    subtle: "_1h6d3acm _1dqonqa1 _syaz1fxt _80om1kdv _16hg18uv _srjtgir2",
    none: "_1h6d3acm _1dqoglyw _syaz1fxt _80om1kdv _16hg18uv _srjtgir2"
};
const $7747ff173c91dd60$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $7747ff173c91dd60$var$getMaxWidth = (width)=>!width ? `100%` : width in $7747ff173c91dd60$var$widthMap ? `${$7747ff173c91dd60$var$widthMap[width]}px` : `${+width}px`;
const $7747ff173c91dd60$var$containerStyleAppearance = {
    standard: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    subtle: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    none: "_1dqoglyw"
};
const $7747ff173c91dd60$var$containerStyles = null;
const $7747ff173c91dd60$var$inputDisabledStyle = null;
const $7747ff173c91dd60$var$inputCompactStyleWithFg = null;
const $7747ff173c91dd60$var$inputCompactStyle = null;
const $7747ff173c91dd60$var$inputMonospacedStyle = null;
const $7747ff173c91dd60$var$inputFontStyleWithFG = null;
const $7747ff173c91dd60$var$inputStyleMonospacedWithFg = null;
const $7747ff173c91dd60$var$inputStyleNotDataCompactWithFG = null;
const $7747ff173c91dd60$var$inputStyle = null; /**
                          * __Textfield__
                          *
                          * A text field is an input that allows a user to write or edit text.
                          *
                          * - [Examples](https://atlassian.design/components/textfield/examples)
                          * - [Code](https://atlassian.design/components/textfield/code)
                          * - [Usage](https://atlassian.design/components/textfield/usage)
                          */ 
const $7747ff173c91dd60$var$Textfield = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $5uXOq.useRef)(null);
    const handleOnFocus = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$7747ff173c91dd60$var$analyticsParams
    });
    const handleOnBlur = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$7747ff173c91dd60$var$analyticsParams
    });
    const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        style: {
            maxWidth: `${$7747ff173c91dd60$var$getMaxWidth(width)}`
        },
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _11c82smr _1reo15vq _18m915vq _v564r5cv _189ee4h9 _1e0c1txw _vchhusvi _4cvr1h6o _1bah1yb4 _lcxv1wug _s7n4jp4b _slp31hna _1tnq1l7b",
            $7747ff173c91dd60$var$getContainerTextBgAndBorderColor[appearance],
            $7747ff173c91dd60$var$containerStyleAppearance[appearance],
            !isDisabled && $7747ff173c91dd60$var$focusWithinStyle[appearance],
            !isDisabled && $7747ff173c91dd60$var$hoverStyle[appearance],
            isDisabled && $7747ff173c91dd60$var$containerMedia.disabled,
            isDisabled && $7747ff173c91dd60$var$disabledStyle[appearance],
            isInvalid && $7747ff173c91dd60$var$containerMedia.invalid,
            isInvalid && "_1h6d1bqt _4cvx1bqt _16qsizbr _1dbzizbr _10j7r01l",
            className
        ]),
        children: [
            elemBeforeInput,
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ...spreadProps,
                "aria-invalid": isInvalid ? isInvalid : undefined,
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                "data-compact": isCompact ? isCompact : undefined,
                "data-ds--text-field--input": true,
                "data-monospaced": isMonospaced ? isMonospaced : undefined,
                "data-testid": testId,
                disabled: isDisabled,
                name: name,
                onBlur: handleOnBlur,
                onChange: onChange,
                onFocus: handleOnFocus,
                placeholder: placeholder,
                readOnly: isReadOnly,
                ref: setInputRef,
                required: isRequired,
                className: (0, $bwpsq.default)([
                    "_19itidpf _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1bsb1osq _1ul9idpf _bfhk18uv _syaz1kw7 _80om1kw7 _14jiu2gc _olc6u2gc _1kod12x7 _7ba012x7 _1goxglyw _13xeglyw _1n7e1l2s _1idr131l",
                    isMonospaced && "_ect41odn",
                    isCompact && "_85i51b66 _1q511b66 _y4ti12x7 _bozg12x7",
                    isDisabled && "_syaz1lh4 _1idr1lh4",
                    isDisabled && "_1fnx18qt",
                    !isCompact && (0, $fHpHg.fg)('platform_design_system_team_safari_input_fix') && "_14ji12x7 _olc612x7 _1kod12x7 _7ba012x7 _l9oiu2gc _549yu2gc _1h5w12x7 _124212x7",
                    (0, $fHpHg.fg)('platform_design_system_team_safari_input_fix') && "_11c81ixg _1tn22smr",
                    isCompact && (0, $fHpHg.fg)('platform_design_system_team_safari_input_fix') && "_11zpv77o _1l02v77o _daj712x7 _141f12x7 _1srd1b66 _oi9h1b66 _1e3012x7 _1txv12x7",
                    isMonospaced && (0, $fHpHg.fg)('platform_design_system_team_safari_input_fix') && "_ect41odn _14md1odn"
                ])
            }),
            elemAfterInput
        ]
    });
});
var $7747ff173c91dd60$export$2e2bcd8739ae039 = $7747ff173c91dd60$var$Textfield;

});

parcelRegister("az4zD", function(module, exports) {

$parcel$export(module.exports, "injectIntlV2", () => $90dc1bd887533804$export$440265f0ca78e98e);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $5uXOq = parcelRequire("5uXOq");

var $dY8Js = parcelRequire("dY8Js");

var $koVbs = parcelRequire("koVbs");
const $90dc1bd887533804$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
function $90dc1bd887533804$var$getDisplayName(Component) {
    if ($90dc1bd887533804$var$isDisplayableString(Component.displayName)) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return Component.displayName;
    if ($90dc1bd887533804$var$isDisplayableString(Component.name)) return Component.name;
    return 'Component';
}
const $90dc1bd887533804$export$440265f0ca78e98e = (WrappedComponent, options)=>{
    const { withRef: withRef = false } = options || {};
    const WithIntl = (props)=>{
        const intl = (0, $koVbs.default)();
        const intlRef = (0, $5uXOq.useRef)(null);
        if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
        if (!intlRef.current) intlRef.current = {
            // @ts-expect-error We force v5 messages type on v2 type
            messages: intl.messages,
            locale: intl.locale,
            formats: intl.formats,
            formatDate: intl.formatDate,
            formatMessage: intl.formatMessage,
            formatNumber: intl.formatNumber,
            formatPlural: intl.formatPlural,
            formatTime: intl.formatTime
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            intl: intlRef.current,
            ref: withRef ? props.forwardedRef : null
        });
    };
    // Changed this display name to be capital letter to prevent snapshots from failing, here is the original: https://github.com/formatjs/formatjs/blob/main/packages/react-intl/src/components/injectIntl.tsx#L98
    WithIntl.displayName = `InjectIntl(${$90dc1bd887533804$var$getDisplayName(WrappedComponent)})`;
    WithIntl.WrappedComponent = WrappedComponent;
    if (withRef) return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WithIntl, {
            ...props,
            forwardedRef: ref
        })), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(WithIntl, WrappedComponent);
};

});

const $27f32c1fbb856eaf$export$399c7e6858236b4 = 'source.code.link';
const $27f32c1fbb856eaf$export$58125ce2bb1c3378 = 'project.shortcut.default.link';
const $27f32c1fbb856eaf$export$3746846b4d8615c3 = 'INVALID_URL';

parcelRegister("6OZbr", function(module, exports) {

$parcel$export(module.exports, "urlSanityCheck", () => $f1821f7cb42157ff$export$fbdce048450ca259);
const $f1821f7cb42157ff$export$fbdce048450ca259 = (url)=>{
    const sanitisedUrl = url.trim();
    const sanityTest = /^((((https?|ftps?):)?\/\/)|((mailto|skype|callto|facetime|git|irc|irc6|news|nntp|feed|cvs|svn|mvn|ssh|itms|notes|smb|hipchat|sourcetree):))[^\s/$.?#].[^\s]*$/i;
    if (sanityTest.test(sanitisedUrl)) return true;
    return false;
};

});

parcelRegister("8hTwx", function(module, exports) {

$parcel$export(module.exports, "default", () => $54f708f9afc2a6d1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6eFvr = parcelRequire("6eFvr");

var $az4zD = parcelRequire("az4zD");

var $3aI2c = parcelRequire("3aI2c");
const $54f708f9afc2a6d1$var$ProTip = (props)=>{
    const { intl: { formatMessage: formatMessage }, id: id } = props;
    const label = formatMessage((0, $3aI2c.default).proTipLabel);
    const message = formatMessage((0, $3aI2c.default).proTipMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($54f708f9afc2a6d1$var$ProTipWrapper, {
        id: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        as: "strong",
        size: "small",
        color: "color.text.subtle"
    }, label, "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        size: "small"
    }, message)));
};
var $54f708f9afc2a6d1$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $az4zD.injectIntlV2)($54f708f9afc2a6d1$var$ProTip);
const $54f708f9afc2a6d1$var$ProTipWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "small", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3aI2c", function(module, exports) {

$parcel$export(module.exports, "default", () => $638c31d11bd6145e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $638c31d11bd6145e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    urlCaption: {
        "id": "navigation-shortcuts.common.messages.link-messages.url-caption",
        "defaultMessage": "Web address"
    },
    urlPlaceholder: {
        "id": "navigation-shortcuts.common.messages.link-messages.url-placeholder",
        "defaultMessage": "e.g. http://www.atlassian.com"
    },
    nameCaption: {
        "id": "navigation-shortcuts.common.messages.link-messages.name-caption",
        "defaultMessage": "Name"
    },
    namePlaceholder: {
        "id": "navigation-shortcuts.common.messages.link-messages.name-placeholder",
        "defaultMessage": "e.g. Atlassian website"
    },
    invalidUrlError: {
        "id": "navigation-shortcuts.common.messages.link-messages.invalid-url-error",
        "defaultMessage": "Please enter a valid URL"
    },
    proTipLabel: {
        "id": "navigation-shortcuts.common.messages.link-messages.pro-tip-label",
        "defaultMessage": "\uD83D\uDE0EPro tip:"
    },
    proTipMessage: {
        "id": "navigation-shortcuts.common.messages.link-messages.pro-tip-message",
        "defaultMessage": "Start your shortcut\u2019s name with an emoji to customize its icon."
    }
});

});



parcelRegister("l5pQE", function(module, exports) {

$parcel$export(module.exports, "default", () => $85326a49386652f4$export$2e2bcd8739ae039);


var $3aI2c = parcelRequire("3aI2c");

var $56VNX = parcelRequire("56VNX");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$85326a49386652f4$export$2e2bcd8739ae039 = (type)=>{
    if (type === (0, $27f32c1fbb856eaf$export$399c7e6858236b4)) return 0, $56VNX.default;
    return 0, $3aI2c.default;
};

});
parcelRegister("56VNX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c229b305b86e4ce$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2c229b305b86e4ce$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    urlCaption: {
        "id": "navigation-shortcuts.common.messages.repo-messages.url-caption",
        "defaultMessage": "Repository link"
    },
    urlPlaceholder: {
        "id": "navigation-shortcuts.common.messages.repo-messages.url-placeholder",
        "defaultMessage": "e.g. https://bitbucket.org/org/projectrepository"
    },
    nameCaption: {
        "id": "navigation-shortcuts.common.messages.repo-messages.name-caption",
        "defaultMessage": "Name"
    },
    namePlaceholder: {
        "id": "navigation-shortcuts.common.messages.repo-messages.name-placeholder",
        "defaultMessage": "e.g. Project repository"
    },
    invalidUrlError: {
        "id": "navigation-shortcuts.common.messages.repo-messages.invalid-url-error",
        "defaultMessage": "Please enter a valid URL"
    }
});

});



parcelRegister("4zTCd", function(module, exports) {

$parcel$export(module.exports, "default", () => $589c479af9bb2ad2$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $cUUCJ = parcelRequire("cUUCJ");

var $g1QfP = parcelRequire("g1QfP");
var $7CjwE = parcelRequire("7CjwE");

var $9fuVs = parcelRequire("9fuVs");

var $7NYq5 = parcelRequire("7NYq5");


var $3gunJ = parcelRequire("3gunJ");

var $evcxe = parcelRequire("evcxe");

var $9uKgx = parcelRequire("9uKgx");
// eslint-disable-next-line jira/react/no-class-components
class $589c479af9bb2ad2$var$AddLinkModal extends (0, $5uXOq.Component) {
    async performAdd() {
        // eslint-disable-next-line jira/deprecations/no-base-url
        const { projectId: projectId, baseUrl: baseUrl, onCompleted: onCompleted, flagService: flagService } = this.props;
        const { name: name, url: url } = this.state;
        try {
            this.setState({
                isInProgress: true
            });
            // eslint-disable-next-line jira/deprecations/no-base-url
            const { id: id } = await (0, $evcxe.default)(baseUrl, {
                projectId: projectId,
                name: name,
                url: url,
                icon: '',
                type: 'project.shortcut.default.link'
            });
            this.setState({
                isInProgress: false
            });
            onCompleted({
                item: {
                    type: 'Item',
                    id: id,
                    text: name,
                    href: url,
                    shortcutType: (0, $27f32c1fbb856eaf$export$58125ce2bb1c3378)
                }
            });
            flagService.showFlag((0, $3gunJ.successFlag)());
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            flagService.showFlag((0, $3gunJ.errorFlag)());
            onCompleted({
                item: undefined
            });
        }
    }
    render() {
        const { url: url, name: name, hasError: hasError } = this.state;
        const isSubmitEnabled = !!url.trim() && !!name.trim() && !hasError;
        const { Content: Content, Header: Header } = this.props;
        const { isInProgress: isInProgress } = this.state;
        const { intl: { formatMessage: formatMessage }, addItemButtonRef: addItemButtonRef } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
            width: "medium",
            onClose: this.onClose,
            autoFocus: false,
            shouldReturnFocus: addItemButtonRef,
            shouldCloseOnOverlayClick: false,
            messageId: "navigation-shortcuts.add-link-modal.modal-dialog",
            messageType: "transactional"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Header, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1QfP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("h1", {
            className: (0, $bwpsq.default)([
                "_19pkidpf"
            ])
        }, formatMessage((0, $9uKgx.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", {
            "aria-hidden": "true",
            className: (0, $bwpsq.default)([
                "_syaz1gjq"
            ])
        }, formatMessage((0, $9uKgx.default).requiredField), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cUUCJ.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Content, {
            onDataChange: this.onDataChange
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CjwE.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
            appearance: "link",
            onClick: this.onClose,
            isDisabled: isInProgress
        }, formatMessage((0, $9uKgx.default).cancelCaption)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
            appearance: "primary",
            onClick: this.onAdd,
            isDisabled: !isSubmitEnabled || isInProgress
        }, formatMessage((0, $9uKgx.default).submitCaption)))));
    }
    constructor(...args){
        super(...args), this.state = {
            url: '',
            name: '',
            hasError: false,
            isInProgress: false
        }, this.onDataChange = ({ url: url, name: name, hasError: hasError })=>{
            // @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
            this.setState({
                url: url,
                name: name,
                hasError: hasError
            });
        }, this.onAdd = ()=>{
            this.performAdd();
        }, this.onClose = ()=>{
            const { onCompleted: onCompleted } = this.props;
            onCompleted({
                item: undefined
            });
        };
    }
}
var $589c479af9bb2ad2$export$2e2bcd8739ae039 = $589c479af9bb2ad2$var$AddLinkModal;
const $589c479af9bb2ad2$var$headingStyles = null;
const $589c479af9bb2ad2$var$requiredTextStyles = null;

});
parcelRegister("3gunJ", function(module, exports) {

$parcel$export(module.exports, "successFlag", () => $f46bc165f383fff4$export$ffdda8067b36a26d);
$parcel$export(module.exports, "errorFlag", () => $f46bc165f383fff4$export$b9a7f1ebeaa76953);

var $boNGU = parcelRequire("boNGU");

var $dw06P = parcelRequire("dw06P");
const $f46bc165f383fff4$export$ffdda8067b36a26d = ()=>({
        type: 'success',
        isAutoDismiss: false,
        delayAnnouncement: 3000,
        ...(0, $dw06P.messages),
        messageId: 'navigation-shortcuts.add-link-modal.flags.flag.success.jira-modal.success',
        messageType: 'transactional'
    });
const $f46bc165f383fff4$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        isAutoDismiss: false,
        delayAnnouncement: 3000,
        ...(0, $boNGU.messages),
        messageId: 'navigation-shortcuts.add-link-modal.flags.flag.error.jira-modal.error',
        messageType: 'transactional'
    });

});
parcelRegister("boNGU", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f2e52626c22497fe$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f2e52626c22497fe$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "navigation-shortcuts.add-link-modal.flags.failure.title",
        "defaultMessage": "Sorry! You were unable to add this link"
    },
    description: {
        "id": "navigation-shortcuts.add-link-modal.flags.failure.description",
        "defaultMessage": "Please try again later"
    }
});

});

parcelRegister("dw06P", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7de96d633909fae2$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7de96d633909fae2$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "navigation-shortcuts.add-link-modal.flags.success.title",
        "defaultMessage": "You have added the shortcut"
    },
    description: {
        "id": "navigation-shortcuts.add-link-modal.flags.success.description",
        "defaultMessage": "Nicely done! Your team is going to love this."
    }
});

});


parcelRegister("evcxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab327582ccf23a79$export$2e2bcd8739ae039);

var $dsmZT = parcelRequire("dsmZT");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ab327582ccf23a79$export$2e2bcd8739ae039 = async (baseUrl, request)=>{
    const result = await (0, $dsmZT.default)(baseUrl, {
        ...request
    });
    return {
        id: result.id
    };
};

});
parcelRegister("dsmZT", function(module, exports) {

$parcel$export(module.exports, "default", () => $52bf61729193c30f$export$2e2bcd8739ae039);

var $7f4tk = parcelRequire("7f4tk");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$52bf61729193c30f$export$2e2bcd8739ae039 = async (baseUrl, request)=>{
    const { projectId: projectId, ...data } = request;
    const url = `${baseUrl}/rest/projects/1.0/project/${projectId}/shortcut`;
    const options = {
        method: 'POST',
        body: JSON.stringify(data)
    };
    return (0, $7f4tk.default)(url, options);
};

});


parcelRegister("9uKgx", function(module, exports) {

$parcel$export(module.exports, "default", () => $d51bcaf680cb83fa$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d51bcaf680cb83fa$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    heading: {
        "id": "navigation-shortcuts.add-link-modal.heading",
        "defaultMessage": "Add shortcut"
    },
    submitCaption: {
        "id": "navigation-shortcuts.add-link-modal.submit-caption",
        "defaultMessage": "Add"
    },
    cancelCaption: {
        "id": "navigation-shortcuts.add-link-modal.cancel-caption",
        "defaultMessage": "Cancel"
    },
    requiredField: {
        "id": "navigation-shortcuts.required-field",
        "defaultMessage": "Required fields are marked with an asterisk"
    }
});

});



parcelRegister("5PRxC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c44c0bed39c9ba24$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nE2n = parcelRequire("7nE2n");

var $az4zD = parcelRequire("az4zD");

var $98nGp = parcelRequire("98nGp");

var $eT3Ul = parcelRequire("eT3Ul");
const $c44c0bed39c9ba24$var$AddRepositoryModalWithIntl = (0, $az4zD.injectIntlV2)((0, $eT3Ul.default));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c44c0bed39c9ba24$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7nE2n.default), null, (flagService)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c44c0bed39c9ba24$var$AddRepositoryModalWithIntl, {
            ...props,
            flagService: flagService,
            Content: (0, $98nGp.default)
        }));

});
parcelRegister("98nGp", function(module, exports) {

$parcel$export(module.exports, "default", () => $80bdd03d76d49c6a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gxpxd = parcelRequire("gxpxd");


var $l5pQE = parcelRequire("l5pQE");
const $80bdd03d76d49c6a$var$messages = (0, $l5pQE.default)((0, $27f32c1fbb856eaf$export$399c7e6858236b4));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$80bdd03d76d49c6a$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gxpxd.default), {
        urlCaption: $80bdd03d76d49c6a$var$messages.urlCaption,
        urlPlaceholder: $80bdd03d76d49c6a$var$messages.urlPlaceholder,
        nameCaption: $80bdd03d76d49c6a$var$messages.nameCaption,
        namePlaceholder: $80bdd03d76d49c6a$var$messages.namePlaceholder,
        urlAndNameLocked: true,
        onChange: props.onDataChange
    });

});

parcelRegister("eT3Ul", function(module, exports) {

$parcel$export(module.exports, "default", () => $c46ece4736dd6483$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $g1QfP = parcelRequire("g1QfP");
var $7CjwE = parcelRequire("7CjwE");
var $eUaFh = parcelRequire("eUaFh");
var $7Sb4G = parcelRequire("7Sb4G");

var $9fuVs = parcelRequire("9fuVs");

var $4R6GH = parcelRequire("4R6GH");

var $7NYq5 = parcelRequire("7NYq5");


var $c87uy = parcelRequire("c87uy");

var $9AuUJ = parcelRequire("9AuUJ");

var $5tuw1 = parcelRequire("5tuw1");
// eslint-disable-next-line jira/react/no-class-components
class $c46ece4736dd6483$var$AddRepositoryModal extends (0, $5uXOq.Component) {
    async performAdd() {
        const { projectId: projectId, baseUrl: baseUrl, onCompleted: onCompleted, flagService: flagService } = this.props;
        const { name: name, url: url } = this.state;
        try {
            this.setState({
                isInProgress: true
            });
            const { id: id } = await (0, $9AuUJ.default)(baseUrl, {
                projectId: projectId,
                name: name,
                url: url,
                icon: '',
                type: 'source.code.link'
            });
            this.setState({
                isInProgress: false
            });
            onCompleted({
                item: {
                    type: 'Item',
                    id: id,
                    text: name,
                    href: url,
                    shortcutType: (0, $27f32c1fbb856eaf$export$399c7e6858236b4)
                }
            });
            // @ts-expect-error - TS2345 - Argument of type '{ title: { id: string; defaultMessage: string; description: string; }; description: { id: string; defaultMessage: string; description: string; }; type: string; }' is not assignable to parameter of type 'Flag'.
            flagService.showFlag((0, $c87uy.successFlag)());
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // @ts-expect-error - TS2345 - Argument of type '{ title: { id: string; defaultMessage: string; description: string; }; description: { id: string; defaultMessage: string; description: string; }; type: string; }' is not assignable to parameter of type 'Flag'.
            flagService.showFlag((0, $c87uy.errorFlag)());
            onCompleted({
                item: undefined
            });
        }
    }
    render() {
        const { Content: Content } = this.props;
        const { isInProgress: isInProgress } = this.state;
        const { intl: { formatMessage: formatMessage } } = this.props;
        const isSubmitEnabled = !!this.state.url.trim() && !!this.state.name.trim();
        const actions = [
            {
                appearance: 'link',
                onClick: this.onClose,
                text: formatMessage((0, $5tuw1.default).cancelCaption),
                isDisabled: isInProgress
            },
            {
                appearance: 'primary',
                onClick: this.onAdd,
                text: formatMessage((0, $5tuw1.default).submitCaption),
                isDisabled: !isSubmitEnabled || isInProgress
            }
        ];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
            onClose: this.onClose,
            autoFocus: true,
            shouldCloseOnOverlayClick: false,
            messageId: "navigation-shortcuts.add-repository-modal.modal-dialog",
            messageType: "transactional"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eUaFh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Sb4G.default), null, formatMessage((0, $5tuw1.default).heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1QfP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $5tuw1.default).descriptionIssueTermRefresh : (0, $5tuw1.default).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Content, {
            onDataChange: this.onDataChange
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CjwE.default), null, actions.map((action)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
                key: `btn-${action.appearance}`,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                appearance: action.appearance,
                onClick: action.onClick,
                isDisabled: action.isDisabled
            }, action.text)))));
    }
    constructor(...args){
        super(...args), this.state = {
            url: '',
            name: '',
            isInProgress: false
        }, this.onClose = ()=>{
            const { onCompleted: onCompleted } = this.props;
            onCompleted({
                item: undefined
            });
        }, this.onAdd = ()=>{
            this.performAdd();
        }, this.onDataChange = ({ url: url, name: name })=>{
            this.setState({
                url: url,
                name: name
            });
        };
    }
}
var $c46ece4736dd6483$export$2e2bcd8739ae039 = $c46ece4736dd6483$var$AddRepositoryModal;

});
parcelRegister("c87uy", function(module, exports) {

$parcel$export(module.exports, "successFlag", () => $62ef145e9796d90a$export$ffdda8067b36a26d);
$parcel$export(module.exports, "errorFlag", () => $62ef145e9796d90a$export$b9a7f1ebeaa76953);

var $kBi8c = parcelRequire("kBi8c");

var $9Tqjs = parcelRequire("9Tqjs");
const $62ef145e9796d90a$export$ffdda8067b36a26d = ()=>({
        type: 'success',
        ...(0, $9Tqjs.messages),
        messageId: 'navigation-shortcuts.add-repository-modal.flags.flag.success',
        messageType: 'transactional'
    });
const $62ef145e9796d90a$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        ...(0, $kBi8c.messages),
        messageId: 'navigation-shortcuts.add-repository-modal.flags.flag.error',
        messageType: 'transactional'
    });

});
parcelRegister("kBi8c", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5534b5b3be38eff4$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5534b5b3be38eff4$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "navigation-shortcuts.add-repository-modal.flags.failure.title",
        "defaultMessage": "Sorry! You were unable to add this repository"
    },
    description: {
        "id": "navigation-shortcuts.add-repository-modal.flags.failure.description",
        "defaultMessage": "Please try again later"
    }
});

});

parcelRegister("9Tqjs", function(module, exports) {

$parcel$export(module.exports, "messages", () => $15689b54461e014e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $15689b54461e014e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "navigation-shortcuts.add-repository-modal.flags.success.title",
        "defaultMessage": "You have added the repository"
    },
    description: {
        "id": "navigation-shortcuts.add-repository-modal.flags.success.description",
        "defaultMessage": "Nicely done! Your team is going to love this."
    }
});

});


parcelRegister("9AuUJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaf3b131300cea00$export$2e2bcd8739ae039);

var $dsmZT = parcelRequire("dsmZT");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$aaf3b131300cea00$export$2e2bcd8739ae039 = async (baseUrl, request)=>{
    const result = await (0, $dsmZT.default)(baseUrl, {
        ...request
    });
    return {
        id: result.id
    };
};

});

parcelRegister("5tuw1", function(module, exports) {

$parcel$export(module.exports, "default", () => $8edf8dbc596e3286$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8edf8dbc596e3286$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    heading: {
        "id": "navigation-shortcuts.add-repository-modal.heading",
        "defaultMessage": "Connect a repository"
    },
    description: {
        "id": "navigation-shortcuts.add-repository-modal.description",
        "defaultMessage": "Linking a repository will show information about your branches, commits and pull requests in Jira issues."
    },
    submitCaption: {
        "id": "navigation-shortcuts.add-repository-modal.submit-caption",
        "defaultMessage": "Connect"
    },
    cancelCaption: {
        "id": "navigation-shortcuts.add-repository-modal.cancel-caption",
        "defaultMessage": "Cancel"
    },
    descriptionIssueTermRefresh: {
        "id": "navigation-shortcuts.add-repository-modal.description-issue-term-refresh",
        "defaultMessage": "Linking a repository will show information about your branches, commits and pull requests in Jira work items."
    }
});

});



parcelRegister("df3S9", function(module, exports) {

$parcel$export(module.exports, "default", () => $110fa6d3396702c3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $jzjy1 = parcelRequire("jzjy1");

var $iQv12 = parcelRequire("iQv12");

var $34Vv8 = parcelRequire("34Vv8");

var $az4zD = parcelRequire("az4zD");


var $l0iMF = parcelRequire("l0iMF");

var $4EF9O = parcelRequire("4EF9O");

var $PU6w1 = parcelRequire("PU6w1");

var $jTdxO = parcelRequire("jTdxO");
const $110fa6d3396702c3$var$InjectedView = (0, $az4zD.injectIntlV2)((0, $jTdxO.default));
// eslint-disable-next-line jira/react/no-class-components
class $110fa6d3396702c3$var$SelectItemTypeModal extends (0, $5uXOq.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($110fa6d3396702c3$var$InjectedView, {
            addItemButtonRef: this.props.addItemButtonRef,
            onClose: this.props.onClose,
            Content: this.renderContent,
            onCloseComplete: this.props.onCloseComplete
        });
    }
    constructor(...args){
        super(...args), this.onEnabledChange = ()=>{
            const { pages: pages } = this.props;
            pages.setPagesLink(!pages.isEnabled).catch(()=>{
                this.props.flagService.showFlag((0, $l0iMF.default)());
            });
        }, this.renderPagesSelector = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $PU6w1.default), {
                isEnabled: this.props.pages.isEnabled,
                onEnabledChange: this.onEnabledChange
            }), this.renderContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4EF9O.default), {
                PagesSelector: this.renderPagesSelector,
                onAddLink: this.props.onAddLink,
                onAddRepo: this.props.onAddRepo,
                showPagesSelector: this.props.showPagesSelector
            });
    }
}
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$110fa6d3396702c3$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $jzjy1.AnalyticsSource)('addNavigationItems', (0, $4d5e0871c06cee03$export$1171103ea9083ffa)), (0, $iQv12.default)({
    onClose: 'close'
}), (0, $34Vv8.default))($110fa6d3396702c3$var$SelectItemTypeModal);

});
parcelRegister("iQv12", function(module, exports) {

$parcel$export(module.exports, "default", () => $945500a9598c3ac2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gvRPW = parcelRequire("gvRPW");
/**
 * Adds analytics events to the given callbacks without altering the original behavior
 * Callback is expected to have analyticsEvent as a last argument
 * @example
 * ```tsx
 *  // will fire "select" event when onSelect is called
 *  fileWithUIAnalytics({ onSelect: 'select' })
 *
 *  // will fire "select" event with extra attributes
 *  fileWithUIAnalytics({ onSelect: (value) => ({ name: 'select', value: value}) }
 *  ```
 */ const $945500a9598c3ac2$var$fireWithUIAnalytics = (ConnectedProps)=>{
    // sort the keys so we can set the deps of useMemo
    const providedKeys = Object.keys(ConnectedProps).sort();
    /**
	 * We implement a custom caching mechanism rather than memoizeOne. We got
	 * more ops/sec this way and we only need to bust the changing props cache
	 * instead of destroying all references on a single prop change.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedMappedProps = {}; /*    the actual prop value */ 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedConnectedProps = {}; /* the connected prop value (the callback) */ 
    const getStateFromMappedProps = (mapped)=>{
        providedKeys.forEach((key, index)=>{
            // firstly check the cache if the prop has changed before creating
            // any new connected props
            const prop = mapped[index];
            if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
            cachedMappedProps[key] = prop;
            // @ts-expect-error - TS7019 - Rest parameter 'attrs' implicitly has an 'any[]' type.
            cachedConnectedProps[key] = (...attrs)=>{
                // assume that analytics event is always the last one (it should be by convention)
                const analyticsEvent = attrs[attrs.length - 1].clone();
                const connectedProp = ConnectedProps[key];
                // example: { onSelect: 'select' }
                if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                    name: connectedProp,
                    analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
                }).fire();
                else if (typeof connectedProp === 'function') {
                    const update = connectedProp(...attrs);
                    analyticsEvent.update({
                        ...update,
                        analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
                    }).fire();
                }
                if (typeof prop === 'function') prop(...attrs);
            };
        });
        return cachedConnectedProps;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any,@typescript-eslint/consistent-type-assertions
        class WithAnalytics extends (0, $5uXOq.Component) {
            static{
                // Note: This seems to render weirdly in the chrome debugger. May need to change the string formatting to work around it
                this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
            }
            render() {
                const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                // @ts-expect-error TS2322: Type {} is not assignable to type
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    ...this.props,
                    ...newMappedProps
                });
            }
        }; // eslint-disable-line @typescript-eslint/no-explicit-any
};
var $945500a9598c3ac2$export$2e2bcd8739ae039 = $945500a9598c3ac2$var$fireWithUIAnalytics;

});

parcelRegister("34Vv8", function(module, exports) {

$parcel$export(module.exports, "default", () => $827c4d80e4d41b48$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");
const $827c4d80e4d41b48$var$withFlagService = (WrappedComponent)=>{
    return (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            flagService: (0, $pa9q9.flagService)
        });
};
var $827c4d80e4d41b48$export$2e2bcd8739ae039 = $827c4d80e4d41b48$var$withFlagService;

});

// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("l0iMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $96817e8de39ea2a2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $96817e8de39ea2a2$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "navigation-shortcuts.flags.set-pages-link-error.title",
        "defaultMessage": "Something went wrong, but we're on it"
    },
    description: {
        "id": "navigation-shortcuts.flags.set-pages-link-error.description",
        "defaultMessage": "In the meantime, refresh this page. Contact support if you keep getting this message."
    }
});
const $96817e8de39ea2a2$var$setPagesLinkErrorFlag = ()=>({
        type: 'error',
        title: $96817e8de39ea2a2$var$messages.title,
        description: $96817e8de39ea2a2$var$messages.description,
        isAutoDismiss: true,
        messageId: 'navigation-shortcuts.flags.set-pages-link-error',
        messageType: 'transactional'
    });
var $96817e8de39ea2a2$export$2e2bcd8739ae039 = $96817e8de39ea2a2$var$setPagesLinkErrorFlag;

});

parcelRegister("4EF9O", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bd9f7ea405749d4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ifhLU = parcelRequire("ifhLU");

var $55Pl0 = parcelRequire("55Pl0");

var $jQ4Lu = parcelRequire("jQ4Lu");
const $8bd9f7ea405749d4$var$injectedProps = {
    LinkSelector: $ifhLU.default,
    RepositorySelector: $55Pl0.default,
    showLinkSelector: true,
    showRepositorySelector: true
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8bd9f7ea405749d4$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jQ4Lu.default), {
        ...props,
        ...$8bd9f7ea405749d4$var$injectedProps
    });

});
parcelRegister("ifhLU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1246e90a0ac2781$export$2e2bcd8739ae039);

var $iQv12 = parcelRequire("iQv12");

var $9V8Kd = parcelRequire("9V8Kd");
var $b1246e90a0ac2781$export$2e2bcd8739ae039 = (0, $iQv12.default)({
    onAdd: 'addLink'
})((0, $9V8Kd.default));

});
parcelRegister("9V8Kd", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2e5e5797b74df16$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3HwlS = parcelRequire("3HwlS");

var $3JBUB = parcelRequire("3JBUB");

var $e9XOa = parcelRequire("e9XOa");

var $iHsDr = parcelRequire("iHsDr");

var $6VaEB = parcelRequire("6VaEB");
class $d2e5e5797b74df16$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e9XOa.default), {
            Action: this.renderAction,
            title: (0, $3HwlS.getWillShowNav4)() ? (0, $6VaEB.default).titleLink : (0, $6VaEB.default).title,
            description: (0, $6VaEB.default).description,
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($iHsDr)))
        });
    }
    constructor(...args){
        super(...args), this.renderAction = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3JBUB.default), {
                onClick: this.props.onAdd,
                ariaLabel: (0, $6VaEB.default).addButtonLabel
            });
    }
}

});
parcelRegister("3JBUB", function(module, exports) {

$parcel$export(module.exports, "default", () => $57dcc110ab673bb6$export$2e2bcd8739ae039);

var $az4zD = parcelRequire("az4zD");

var $4VhqZ = parcelRequire("4VhqZ");
var $57dcc110ab673bb6$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)((0, $4VhqZ.default));

});
parcelRegister("4VhqZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f53cc5be8ecdd0c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $6cgj8 = parcelRequire("6cgj8");
const $1f53cc5be8ecdd0c$var$AddButton = (props)=>{
    const { intl: { formatMessage: formatMessage }, onClick: onClick, ariaLabel: ariaLabel } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        onClick: onClick,
        "aria-label": formatMessage(ariaLabel)
    }, formatMessage((0, $6cgj8.default).add));
};
var $1f53cc5be8ecdd0c$export$2e2bcd8739ae039 = $1f53cc5be8ecdd0c$var$AddButton;

});
parcelRegister("6cgj8", function(module, exports) {

$parcel$export(module.exports, "default", () => $407c6aae1c38c648$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $407c6aae1c38c648$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    add: {
        "id": "navigation-shortcuts.main.select-item-type-modal.content.add-button.add",
        "defaultMessage": "Add"
    }
});

});



parcelRegister("e9XOa", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3287dffd4c43386$export$2e2bcd8739ae039);

var $az4zD = parcelRequire("az4zD");

var $k47b7 = parcelRequire("k47b7");
var $c3287dffd4c43386$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)((0, $k47b7.default));

});
parcelRegister("k47b7", function(module, exports) {

$parcel$export(module.exports, "default", () => $799c7dcffac80d17$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bWfiu = parcelRequire("bWfiu");
function $799c7dcffac80d17$var$TypeSelector(props) {
    const { Action: Action, title: title, description: description, imageUrl: imageUrl } = props;
    const { intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($799c7dcffac80d17$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($799c7dcffac80d17$var$Image, {
        src: imageUrl,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($799c7dcffac80d17$var$Description, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
        size: "small",
        as: "h2"
    }, formatMessage(title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage(description))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($799c7dcffac80d17$var$ToggleIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Action, null)));
}
var $799c7dcffac80d17$export$2e2bcd8739ae039 = $799c7dcffac80d17$var$TypeSelector;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $799c7dcffac80d17$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $799c7dcffac80d17$var$Image = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb53f4 _4t3i1wug _2hwxxy5q",
            __cmplp.className
        ])
    });
});
const $799c7dcffac80d17$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _2hwxxy5q",
            __cmplp.className
        ])
    });
});
const $799c7dcffac80d17$var$ToggleIconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1o9zidpf",
            __cmplp.className
        ])
    });
});

});


parcelRegister("iHsDr", function(module, exports) {
module.exports = new URL("image.4cfe7932.svg", import.meta.url).toString();

});

parcelRegister("6VaEB", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff3d3c15e95dbecc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ff3d3c15e95dbecc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "navigation-shortcuts.main.select-item-type-modal.content.link-selector.title",
        "defaultMessage": "Shortcut"
    },
    description: {
        "id": "navigation-shortcuts.main.select-item-type-modal.content.link-selector.description",
        "defaultMessage": "Add a link to a frequently used resource, like a web page."
    },
    titleLink: {
        "id": "navigation-shortcuts.main.add-item.select-item-type-modal.content.type-selectors.link.title-link",
        "defaultMessage": "Link"
    },
    addButtonLabel: {
        "id": "navigation-shortcuts.main.select-item-type-modal.content.link-selector.add-button-label",
        "defaultMessage": "Add shortcut"
    }
});

});



parcelRegister("55Pl0", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdb6f572e5561b9b$export$2e2bcd8739ae039);

var $iQv12 = parcelRequire("iQv12");

var $aoftl = parcelRequire("aoftl");
var $bdb6f572e5561b9b$export$2e2bcd8739ae039 = (0, $iQv12.default)({
    onAdd: 'addRepository'
})((0, $aoftl.default));

});
parcelRegister("aoftl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba776b7728afe8d8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $3JBUB = parcelRequire("3JBUB");

var $e9XOa = parcelRequire("e9XOa");

var $9JUDj = parcelRequire("9JUDj");

var $ix4tg = parcelRequire("ix4tg");
class $ba776b7728afe8d8$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e9XOa.default), {
            Action: this.renderAction,
            title: (0, $ix4tg.default).title,
            description: (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $ix4tg.default).descriptionIssueTermRefresh : (0, $ix4tg.default).description,
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($9JUDj)))
        });
    }
    constructor(...args){
        super(...args), this.renderAction = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3JBUB.default), {
                onClick: this.props.onAdd,
                ariaLabel: (0, $ix4tg.default).addButtonLabel
            });
    }
}

});
parcelRegister("9JUDj", function(module, exports) {
module.exports = new URL("repository.8c379835.svg", import.meta.url).toString();

});

parcelRegister("ix4tg", function(module, exports) {

$parcel$export(module.exports, "default", () => $01f677d820659dba$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $01f677d820659dba$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "navigation-shortcuts.main.select-item-type-modal.content.repository-selector.title",
        "defaultMessage": "Repository"
    },
    description: {
        "id": "navigation-shortcuts.main.select-item-type-modal.content.repository-selector.description",
        "defaultMessage": "Add a Bitbucket or GitHub repository to show information about branches, commits and pull requests in Jira issues."
    },
    addButtonLabel: {
        "id": "navigation-shortcuts.main.select-item-type-modal.content.repository-selector.add-button-label",
        "defaultMessage": "Add repository"
    },
    descriptionIssueTermRefresh: {
        "id": "navigation-shortcuts.main.select-item-type-modal.content.repository-selector.description-issue-term-refresh",
        "defaultMessage": "Add a Bitbucket or GitHub repository to show information about branches, commits and pull requests in Jira work items."
    }
});

});



parcelRegister("jQ4Lu", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ae7a0465701b140$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $bEIgH = parcelRequire("bEIgH");
function $9ae7a0465701b140$export$7c6e2c02157bb7d2(props) {
    const { LinkSelector: LinkSelector, PagesSelector: PagesSelector, RepositorySelector: RepositorySelector, showLinkSelector: showLinkSelector, showPagesSelector: showPagesSelector, showRepositorySelector: showRepositorySelector, onAddLink: onAddLink, onAddRepo: onAddRepo } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        paddingBlockStart: "space.200",
        paddingInlineEnd: "space.100",
        paddingBlockEnd: "space.0",
        paddingInlineStart: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.400"
    }, showLinkSelector && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LinkSelector, {
        onAdd: onAddLink
    }), showRepositorySelector && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RepositorySelector, {
        onAdd: onAddRepo
    }), showPagesSelector && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(PagesSelector, null)));
}
var $9ae7a0465701b140$export$2e2bcd8739ae039 = $9ae7a0465701b140$export$7c6e2c02157bb7d2;

});


parcelRegister("PU6w1", function(module, exports) {

$parcel$export(module.exports, "default", () => $86a7ddc1093217d5$export$2e2bcd8739ae039);

var $iQv12 = parcelRequire("iQv12");

var $az4zD = parcelRequire("az4zD");

var $7KFor = parcelRequire("7KFor");
var $86a7ddc1093217d5$export$2e2bcd8739ae039 = (0, $iQv12.default)({
    onEnabledChange: 'pages'
})((0, $az4zD.injectIntlV2)((0, $7KFor.default)));

});
parcelRegister("7KFor", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dcacd351fafd914$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fHMtf = parcelRequire("fHMtf");

var $fMTnd = parcelRequire("fMTnd");

var $2uVZm = parcelRequire("2uVZm");

var $e9XOa = parcelRequire("e9XOa");

var $figaw = parcelRequire("figaw");
// eslint-disable-next-line jira/react/no-class-components
class $9dcacd351fafd914$var$PagesSelector extends (0, $5uXOq.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e9XOa.default), {
            Action: this.renderAction,
            title: (0, $figaw.default).title,
            description: (0, $2uVZm.default).enablePagesLinkText,
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($fMTnd)))
        });
    }
    constructor(...args){
        super(...args), this.renderAction = ()=>{
            const { formatMessage: formatMessage } = this.props.intl;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHMtf.default), {
                isChecked: this.props.isEnabled,
                onChange: this.props.onEnabledChange,
                label: formatMessage((0, $figaw.default).title)
            });
        };
    }
}
var $9dcacd351fafd914$export$2e2bcd8739ae039 = $9dcacd351fafd914$var$PagesSelector;

});
parcelRegister("fHMtf", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d8dd5ff816ae367$export$2e2bcd8739ae039);
/* toggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $eNCZ4 = parcelRequire("eNCZ4");

var $bKnKN = parcelRequire("bKnKN");

var $jJsBW = parcelRequire("jJsBW");

var $aWYDr = parcelRequire("aWYDr");

var $9ojbB = parcelRequire("9ojbB");

var $fHpHg = parcelRequire("fHpHg");

var $8nOMf = parcelRequire("8nOMf");
const $1d8dd5ff816ae367$var$basicStyles = null;
const $1d8dd5ff816ae367$var$borderStyles = null;
const $1d8dd5ff816ae367$var$iconStyles = null;
const $1d8dd5ff816ae367$var$sizeStyles = {
    regular: "_2rkopxbi _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf _p9c41fbe",
    large: "_2rkov47k _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz _p9c4w12q"
};
const $1d8dd5ff816ae367$var$noop = (0, $bKnKN.default);
const $1d8dd5ff816ae367$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $1d8dd5ff816ae367$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
}; /**
    * __Toggle__
    *
    * A toggle is used to view or switch between enabled or disabled states.
    *
    * - [Examples](https://atlassian.design/components/toggle/examples)
    * - [Code](https://atlassian.design/components/toggle/code)
    * - [Usage](https://atlassian.design/components/toggle/usage)
    */ 
const $1d8dd5ff816ae367$var$Toggle = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $1d8dd5ff816ae367$var$noop, onChange: providedChange = $1d8dd5ff816ae367$var$noop, onFocus: providedFocus = $1d8dd5ff816ae367$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $5uXOq.useState)(defaultChecked);
    const [isKeyboardUsed, setIsKeyboardUsed] = (0, $5uXOq.useState)(true);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (id && wrapperRef.current && wrapperRef.current.parentElement) {
            /*
      	DSP-21524 Handling the click on <label> that is linked via "for" attribute.
      	By default click on the label fires absolutely same onclick event as click on the input element.
      	To differentiate keyboard click from mouse we need this additional listener.
      */ const linkedLabel = wrapperRef.current.parentElement.querySelector(`label[for="${id}"]`);
            if (linkedLabel) {
                const unbind = (0, $cBeZP.bindAll)(linkedLabel, [
                    {
                        type: 'click',
                        listener: (event)=>{
                            setIsKeyboardUsed(false);
                            if (event?.detail > 1) /*
              DSP-21524 double or triple click on label initiating the text selection for label text and adds additional step to tab order.
              So here we set the isKeyboardUsed to true, to display focus ring on next Tab press
              */ setIsKeyboardUsed(true);
                        }
                    }
                ]);
                return unbind;
            }
        }
    }, [
        id,
        wrapperRef,
        isKeyboardUsed
    ]);
    const handleBlur = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isKeyboardUsed) setIsKeyboardUsed(true);
            providedOnBlur(event, analyticsEvent);
        },
        action: 'blur',
        analyticsData: analyticsContext,
        ...$1d8dd5ff816ae367$var$analyticsAttributes
    });
    const handleFocus = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$1d8dd5ff816ae367$var$analyticsAttributes
    });
    const handleChange = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$1d8dd5ff816ae367$var$analyticsAttributes
    });
    const onLabelKeyDown = (event)=>{
        if ([
            ' ',
            'Tab',
            'Space'
        ].includes(event.key)) setIsKeyboardUsed(true);
    };
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined,
        // DSP-21524 Because label gets focus ring via focus-within and focus-within also triggers by mouse click we have to manually control the ring appearance.
        onKeyDown: onLabelKeyDown,
        onMouseDown: ()=>{
            setIsKeyboardUsed(false);
        }
    };
    const legacyIconSize = $1d8dd5ff816ae367$var$iconSizeMap[size];
    const labelId = (0, $jJsBW.useId)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("label", {
        ...controlProps,
        ref: wrapperRef,
        className: (0, $bwpsq.default)([
            "_v564kete _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1o8l _vchh18uv _kqswh2mm _1y1m1ntv _bfhk76s1 _syaz5w2r _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1i2uidpf _1i3tidpf _se28idpf _3tunidpf _1423idpf _1hrtidpf _1bz2idpf _rqfvidpf _1yc0glyw _onsr1snc _1vgmagmp _1av610yn _1ulhidpf _rfx31q5u _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _7dwzglyw _1bki1y1w _1flt1y1w _3xv21y1w _9471g4a2 _ucab5w2r _mqf815t7 _3dj215t7 _1dl915t7 _1div5w2r _1il8kb7n _y54d5w2r _irr353wy _d0altlke _19ja13gf _8muf13gf _1k1q13gf _1plud4ly _1uo853wy _178c1y1w _16rslghj _ogf41r31 _1rtbnqa1 _5gg9t94y",
            isKeyboardUsed && "_jyzf194a _1r4mnqa1 _1t9pyh40",
            size === 'large' && !(0, $fHpHg.fg)('platform-visual-refresh-icons') && "_1n82gktf _19vpgktf",
            $1d8dd5ff816ae367$var$sizeStyles[size]
        ]),
        children: [
            label ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: labelId,
                hidden: true,
                children: label
            }) : null,
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ref: ref,
                checked: shouldChecked,
                disabled: isDisabled,
                id: id,
                name: name,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                type: "checkbox",
                value: value,
                "data-testid": testId && `${testId}--input`,
                "aria-labelledby": label ? labelId : undefined,
                "aria-describedby": descriptionId
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8nOMf.default), {
                size: size,
                isHidden: !shouldChecked,
                position: "left",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aWYDr))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-check-icon`
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8nOMf.default), {
                size: size,
                isHidden: shouldChecked,
                position: "right",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9ojbB))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-cross-icon`
                })
            })
        ]
    });
}));
$1d8dd5ff816ae367$var$Toggle.displayName = 'Toggle';
var $1d8dd5ff816ae367$export$2e2bcd8739ae039 = $1d8dd5ff816ae367$var$Toggle;

});
parcelRegister("aWYDr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90a6c328ce4531920c578790d71561aa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f8e5b0cf2a75074$var$_react = $7f8e5b0cf2a75074$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7f8e5b0cf2a75074$var$_checkMark = $7f8e5b0cf2a75074$var$_interopRequireDefault((parcelRequire("aiSXl")));

var $7f8e5b0cf2a75074$var$_done = $7f8e5b0cf2a75074$var$_interopRequireDefault((parcelRequire("4UpSr")));
function $7f8e5b0cf2a75074$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7f8e5b0cf2a75074$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $7f8e5b0cf2a75074$var$_react.default.createElement($7f8e5b0cf2a75074$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $7f8e5b0cf2a75074$var$_done.default
    }, props));
$7f8e5b0cf2a75074$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $7f8e5b0cf2a75074$var$_default = module.exports.default = $7f8e5b0cf2a75074$var$CheckMarkIcon;

});
parcelRegister("aiSXl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f681ccdbe722d68d6bd374c0928f0bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $780636fcbb2cccd4$var$_react = $780636fcbb2cccd4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $780636fcbb2cccd4$var$_baseNew = $780636fcbb2cccd4$var$_interopRequireDefault((parcelRequire("enEmH")));
function $780636fcbb2cccd4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $780636fcbb2cccd4$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $780636fcbb2cccd4$var$_react.default.createElement($780636fcbb2cccd4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m11.06 3-6.25 7a.75.75 0 0 1-1.15-.037l-2.75-3.5 1.18-.926 2.197 2.796L9.94 2z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$780636fcbb2cccd4$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $780636fcbb2cccd4$var$_default = module.exports.default = $780636fcbb2cccd4$var$CheckMarkIcon;

});

parcelRegister("4UpSr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3930770d7c775047$var$_react = $3930770d7c775047$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $3930770d7c775047$var$_checkMark = $3930770d7c775047$var$_interopRequireDefault((parcelRequire("dVU8x")));
function $3930770d7c775047$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3930770d7c775047$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $3930770d7c775047$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $3930770d7c775047$var$_checkMark.default
    }));
$3930770d7c775047$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $3930770d7c775047$var$_default = module.exports.default = $3930770d7c775047$var$EditorDoneIcon;

});
parcelRegister("dVU8x", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a24c24cfbaad63c1$var$_react = $a24c24cfbaad63c1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a24c24cfbaad63c1$var$_baseNew = $a24c24cfbaad63c1$var$_interopRequireDefault((parcelRequire("enEmH")));
function $a24c24cfbaad63c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a24c24cfbaad63c1$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $a24c24cfbaad63c1$var$_react.default.createElement($a24c24cfbaad63c1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$a24c24cfbaad63c1$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $a24c24cfbaad63c1$var$_default = module.exports.default = $a24c24cfbaad63c1$var$CheckMarkIcon;

});



parcelRegister("9ojbB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c13696afcc546e8bf0fe91a6c236c8d3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d653cee5ee628ba$var$_react = $6d653cee5ee628ba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6d653cee5ee628ba$var$_cross = $6d653cee5ee628ba$var$_interopRequireDefault((parcelRequire("gANiX")));

var $6d653cee5ee628ba$var$_close = $6d653cee5ee628ba$var$_interopRequireDefault((parcelRequire("gKTT6")));
function $6d653cee5ee628ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6d653cee5ee628ba$var$CrossIcon = (props)=>/*#__PURE__*/ $6d653cee5ee628ba$var$_react.default.createElement($6d653cee5ee628ba$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $6d653cee5ee628ba$var$_close.default
    }, props));
$6d653cee5ee628ba$var$CrossIcon.Name = 'CrossIconMigration';
var $6d653cee5ee628ba$var$_default = module.exports.default = $6d653cee5ee628ba$var$CrossIcon;

});
parcelRegister("gKTT6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c32c4b58a13c4296$var$_react = $c32c4b58a13c4296$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $c32c4b58a13c4296$var$_close = $c32c4b58a13c4296$var$_interopRequireDefault((parcelRequire("eh9vz")));
function $c32c4b58a13c4296$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c32c4b58a13c4296$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $c32c4b58a13c4296$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $c32c4b58a13c4296$var$_close.default
    }));
$c32c4b58a13c4296$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $c32c4b58a13c4296$var$_default = module.exports.default = $c32c4b58a13c4296$var$EditorCloseIcon;

});


parcelRegister("8nOMf", function(module, exports) {

$parcel$export(module.exports, "default", () => $300b858f6a112f45$export$2e2bcd8739ae039);
/* icon-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6tzHJ = parcelRequire("6tzHJ");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");
const $300b858f6a112f45$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $300b858f6a112f45$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        as: "span",
        xcss: (0, $6tzHJ.cx)($300b858f6a112f45$var$styles.iconContainer, isHidden && (0, $fHpHg.fg)('platform-visual-refresh-icons') && $300b858f6a112f45$var$styles.hidden, size === 'regular' && $300b858f6a112f45$var$styles.iconContainerRegular, size === 'large' && $300b858f6a112f45$var$styles.iconContainerLarge, position === 'left' && $300b858f6a112f45$var$styles.left, position === 'right' && $300b858f6a112f45$var$styles.right),
        children: children
    });
};
var $300b858f6a112f45$export$2e2bcd8739ae039 = $300b858f6a112f45$var$IconContainer;

});


parcelRegister("fMTnd", function(module, exports) {
module.exports = new URL("confluence-pages.bd4cb8cc.svg", import.meta.url).toString();

});

parcelRegister("2uVZm", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dc8e4afe9500c07$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $1dc8e4afe9500c07$var$messages = (0, $7VHMR.defineMessages)({
    enablePagesLinkText: {
        "id": "navigation-shortcuts.common.messages.pages-messages.enable-pages-link-text",
        "defaultMessage": "Create, share and collaborate on all your project docs in one place with Confluence pages."
    }
});
var $1dc8e4afe9500c07$export$2e2bcd8739ae039 = $1dc8e4afe9500c07$var$messages;

});

parcelRegister("figaw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e03d5cc848416dc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3e03d5cc848416dc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "navigation-shortcuts.main.select-item-type-modal.content.pages-selector.title",
        "defaultMessage": "Project pages"
    }
});

});



parcelRegister("jTdxO", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e975e7a80831a75$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $g1QfP = parcelRequire("g1QfP");
var $7CjwE = parcelRequire("7CjwE");
var $eUaFh = parcelRequire("eUaFh");
var $7Sb4G = parcelRequire("7Sb4G");

var $7NYq5 = parcelRequire("7NYq5");

var $hZHze = parcelRequire("hZHze");

var $9fuVs = parcelRequire("9fuVs");

var $3HwlS = parcelRequire("3HwlS");

var $2e5mR = parcelRequire("2e5mR");
function $8e975e7a80831a75$var$SelectItemTypeModal(props) {
    const { Content: Content, intl: { formatMessage: formatMessage }, onClose: onClose, onCloseComplete: onCloseComplete, addItemButtonRef: addItemButtonRef } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        messageId: "navigation-shortcuts.main.select-item-type-modal.ak-modal-dialog",
        messageType: "transactional",
        shouldReturnFocus: addItemButtonRef,
        width: "medium",
        onClose: onClose,
        autoFocus: true,
        onCloseComplete: onCloseComplete,
        shouldCloseOnOverlayClick: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eUaFh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Sb4G.default), null, (0, $3HwlS.getWillShowNav4)() ? formatMessage((0, $2e5mR.default).headerShortcuts) : formatMessage((0, $2e5mR.default).header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1QfP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Content, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CjwE.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "link",
        onClick: onClose
    }, formatMessage((0, $2e5mR.default).cancel)))));
}
var $8e975e7a80831a75$export$2e2bcd8739ae039 = $8e975e7a80831a75$var$SelectItemTypeModal;

});
parcelRegister("hZHze", function(module, exports) {

$parcel$export(module.exports, "default", () => $69dc4a27be9f367e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $asiGE = parcelRequire("asiGE");
var $3TR0I = parcelRequire("3TR0I");

var $gvRPW = parcelRequire("gvRPW");
// eslint-disable-next-line jira/react/no-class-components
class $69dc4a27be9f367e$var$ViewTracker extends (0, $5uXOq.Component) {
    componentDidMount() {
        this.props.onMount();
    }
    render() {
        return null;
    }
}
const $69dc4a27be9f367e$var$ViewTrackerWithAnalytics = (0, $asiGE.default)({
    componentName: 'view-tracker'
})((0, $3TR0I.default)({
    onMount: (createEvent)=>createEvent({
            action: (0, $gvRPW.PAGE_EVENT_ACTION)
        }).fire()
})($69dc4a27be9f367e$var$ViewTracker));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$69dc4a27be9f367e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($69dc4a27be9f367e$var$ViewTrackerWithAnalytics, {
        onMount: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    });

});

parcelRegister("2e5mR", function(module, exports) {

$parcel$export(module.exports, "default", () => $308bbbc53944deb8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $308bbbc53944deb8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    header: {
        "id": "navigation-shortcuts.main.select-item-type-modal.header",
        "defaultMessage": "Add an item to this project"
    },
    headerShortcuts: {
        "id": "navigation-shortcuts.main.select-item-type-modal.header-shortcuts",
        "defaultMessage": "Add shortcut"
    },
    close: {
        "id": "navigation-shortcuts.main.select-item-type-modal.close",
        "defaultMessage": "Close"
    },
    cancel: {
        "id": "navigation-shortcuts.main.select-item-type-modal.cancel",
        "defaultMessage": "Cancel"
    }
});

});



parcelRegister("gfzrp", function(module, exports) {

$parcel$export(module.exports, "default", () => $69d0e67ceddea1c6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$69d0e67ceddea1c6$export$2e2bcd8739ae039 = (props)=>{
    const { itemType: itemType, AddRepositoryModal: AddRepositoryModal, AddLinkModal: AddLinkModal, SelectItemTypeModal: SelectItemTypeModal } = props;
    if (itemType === 'repository') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AddRepositoryModal, null);
    if (itemType === 'link') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AddLinkModal, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SelectItemTypeModal, null);
};

});



//# sourceMappingURL=async-navigation-shortcuts.a0fa4530.js.map
